var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.52,
    height: 22.7,
    viewBox: "0 0 18.52 22.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-place"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.26,
    cy: 21.6,
    rx: 2.9,
    ry: 0.7,
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,20.2C5.7,17.4,2.5,13,3.7,7.7a9,9,0,0,1,9-7h0a9,9,0,0,1,9,7c1.2,5.3-2,9.7-4.9,12.5a5.58,5.58,0,0,1-4.1,1.6A5.21,5.21,0,0,1,8.6,20.2ZM5.1,8c-1,4.6,1.9,8.6,4.5,11.1a4.48,4.48,0,0,0,6.1,0c2.6-2.5,5.5-6.5,4.5-11.2a7.45,7.45,0,0,0-7.5-5.8A7.65,7.65,0,0,0,5.1,8Z",
    transform: "translate(-3.44 -0.7)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1,8a2.6,2.6,0,0,1,5.2,0,2.6,2.6,0,0,1-5.2,0Zm.6,0a1.9,1.9,0,1,0,1.9-1.9A2,2,0,0,0,10.7,8Z",
    transform: "translate(-3.44 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,15.2c0-1.6-1.6-2.8-3.5-2.8s-3.5,1.3-3.5,2.8a.32.32,0,0,1-.3.3.45.45,0,0,1-.3-.3c0-1.9,1.9-3.5,4.2-3.5S17,13.3,17,15.2a.32.32,0,0,1-.3.3C16.6,15.5,16.2,15.3,16.2,15.2Z",
    transform: "translate(-3.44 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-3.44 -0.7)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-3.44 -0.7)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlace);
export default __webpack_public_path__ + "static/media/user-place.f116da7bf2ad26376d2092ee871456a3.svg";
export { ForwardRef as ReactComponent };